"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
var ConnectsToConnectionsCell_1 = require("../../components/datagrid/cellFormatters/ConnectsToConnectionsCell");
var CountBarCellFormatter_1 = require("../../components/datagrid/cellFormatters/CountBarCellFormatter");
var DatasourceTypeCell_1 = require("../../components/datagrid/cellFormatters/DatasourceTypeCell");
var IconCellFormatter_1 = require("../../components/datagrid/cellFormatters/IconCellFormatter");
var QualityCellFormatter_1 = require("../../components/datagrid/cellFormatters/QualityCellFormatter");
var TextCellFormatter_1 = require("../../components/datagrid/cellFormatters/TextCellFormatter");
var DataQualityIconHeaderFormatFactory_1 = require("../../components/datagrid/headerFormatters/DataQualityIconHeaderFormatFactory");
var SortableHeaderFormatter_1 = require("../../components/datagrid/headerFormatters/SortableHeaderFormatter");
var TypedDataGridInterfaces_1 = require("../../components/datagrid/TypedDataGridInterfaces");
var ExplorerStyledDisplayGrid_1 = require("../../components/sharedDisplayGrid/ExplorerStyledDisplayGrid");
var UserDisplayComponent_1 = require("../../components/UserDisplayComponent");
var ConnectToDatasourcesSortProvider_1 = require("../../sorting/sortProviders/ConnectToDatasourcesSortProvider");
var ConnectToErrorHandling_1 = require("../ConnectToErrorHandling");
var columns = [
    function () { return ({
        name: 'warning',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: QualityCellFormatter_1.createDataQualityCellFormatter(function (r) { return !r.dataQualityIndicator ? undefined : __assign({ kind: 'indicator', assetName: r.name, 
            // Because this is an indicator, not a fragment from GraphQL, we need to assert
            // that this came from a published datasource and not from any other asset type.
            assetType: 'PublishedDatasource', assetUrl: function (x) { return x.datasourceUrl(r.id); } }, r.dataQualityIndicator); }, function (rowData) { return !rowData.isSupported; }, true, 'connect-to-dialog-data-grid-stacking-root'),
        headerText: '',
        headerFormatter: DataQualityIconHeaderFormatFactory_1.DataQualityIconHeaderFormatterFactory,
        resizable: false,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'isCertified',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: IconCellFormatter_1.createIconCellFormatter(function (_a) {
            var isCertified = _a.isCertified, hasExtracts = _a.hasExtracts, certifier = _a.certifier, certificationNote = _a.certificationNote;
            return (React.createElement(DatasourceTypeCell_1.DatasourceTypeCell, { isCertified: isCertified, hasExtracts: hasExtracts, certifier: certifier, certificationNote: certificationNote, linksDisabled: true, zIndex: 999 }));
        }, function (_a) {
            var hasExtracts = _a.hasExtracts;
            return getDSHoverTitleString(hasExtracts);
        }, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        resizable: false,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: ConnectToDatasourcesSortProvider_1.DatasourceWebclientOrderField.name,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var name = _a.name;
            return name;
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        growToFit: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbookConnectionCount',
        dataKey: ConnectToDatasourcesSortProvider_1.DatasourceWebclientOrderField.connectedWorkbooksCount,
        cellFormatter: CountBarCellFormatter_1.createCountBarCellFormatter(function (_a) {
            var workbookConnectionCount = _a.workbookConnectionCount;
            return workbookConnectionCount;
        }, function (_a) {
            var workbookMaxCount = _a.workbookMaxCount;
            return workbookMaxCount ? workbookMaxCount : null;
        }, 'connectTo', function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderConnectionCountWorkbooks(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'extractLastUpdateTime',
        dataKey: ConnectToDatasourcesSortProvider_1.DatasourceWebclientOrderField.lastRefreshedAt,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var hasExtracts = _a.hasExtracts, extractLastUpdateTime = _a.extractLastUpdateTime;
            return !hasExtracts
                ? Localize_1.Messages.LiveConnection()
                : extractLastUpdateTime !== null
                    ? Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(extractLastUpdateTime))
                    : '';
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderLastExtract(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'connections',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        cellFormatter: createConnectsToCell(),
        headerText: Localize_1.Messages.GridHeaderConnections(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'project',
        dataKey: ConnectToDatasourcesSortProvider_1.DatasourceWebclientOrderField.projectName,
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var project = _a.project;
            return project;
        }, undefined, function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.GridHeaderProject(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'owner',
        dataKey: ConnectToDatasourcesSortProvider_1.DatasourceWebclientOrderField.ownerName,
        // We aren't using the userNameCellFormatter here because it doesn't support "disabled",
        // and we want to render plain text, not a link.
        cellFormatter: TextCellFormatter_1.createTextCellFormatter(function (_a) {
            var owner = _a.owner;
            return UserDisplayComponent_1.isUserInfoVisible(owner) ? UserDisplayComponent_1.getUserNameForDisplay(owner) : null;
        }, Localize_1.Messages.HiddenUser(), function (rowData) { return !rowData.isSupported; }),
        headerText: Localize_1.Messages.Owner(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        sortable: true,
    }); },
];
function createColumns(orderBy, updateSortOrder) {
    var gridSortProps = { orderBy: orderBy, updateSortOrder: updateSortOrder };
    return columns.map(function (columnFactory) { return columnFactory(gridSortProps); });
}
var ConnectToDatasourcesDisplayGrid = /** @class */ (function (_super) {
    __extends(ConnectToDatasourcesDisplayGrid, _super);
    function ConnectToDatasourcesDisplayGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line:typedef
        _this.columns = reselect_1.defaultMemoize(createColumns);
        return _this;
    }
    ConnectToDatasourcesDisplayGrid.prototype.render = function () {
        return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: this.columns(this.props.orderBy, this.props.updateSortOrder), emptyGridMessage: this.props.hasFilter ? Localize_1.Messages.EmptyConnectToGridWithFilter() : Localize_1.Messages.EmptyConnectToGridWithoutFilter(), rowCount: this.props.rowCount, rowStore: this.props.rowStore, selectedKeys: this.props.selectedKeys, selectionMode: ExplorerStyledDisplayGrid_1.SelectionMode.Row, updateSelectionForKey: this.props.updateSelectionForKey, renderErrors: ConnectToErrorHandling_1.reportConnectToWebClientErrors, orderBy: this.props.orderBy, updateSortOrder: this.props.updateSortOrder }));
    };
    return ConnectToDatasourcesDisplayGrid;
}(React.Component));
exports.ConnectToDatasourcesDisplayGrid = ConnectToDatasourcesDisplayGrid;
function createConnectsToCell() {
    return function (props) {
        return (React.createElement(ConnectsToConnectionsCell_1.ConnectsToCell, { connectionDetails: props.row.data.connectionDetails, disabled: !props.row.data.isSupported }));
    };
}
function getDSHoverTitleString(hasExtracts) {
    return hasExtracts ? Localize_1.Messages.DataDetailsDatasourceExtract() : Localize_1.Messages.DataDetailsDatasourceLive();
}
//# sourceMappingURL=ConnectToDatasourcesDisplayGrid.js.map